// src/config/routes/public.routes.ts
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const publicRoutes: RouteConfig[] = [
  // {
  //   name: "Login",
  //   path: "/auth/login",
  //   component: lazy(() => import('src/pages/auth/login/LoaginPage')),
  //   showInSideNav: true,
  //   access: ["*"], // Accessible to everyone
  //   breadcrumbPath: ["login"],
  //   isDefaultFor: ["*"],
  //   icon: "login",
  //   order: 1,
  //   meta: {
  //     title: "Welcome to Our Platform",
  //     description: "Your trusted partner for consumer services",
  //     requiresAuth: false,
  //     layout: "public",
  //     analytics: {
  //       category: "Public",
  //       action: "Home_View"
  //     }
  //   }
  // },
  // {
  //   name: "Signup",
  //   path: "/auth/signup",
  //   component: lazy(() => import('src/pages/auth/signup/SignUpPage')),
  //   showInSideNav: true,
  //   access: ["*"], // Accessible to everyone
  //   breadcrumbPath: ["signup"],
  //   icon: "signup",
  //   order: 2,
  //   meta: {
  //     title: "Create Your Account",
  //     description: "Join our platform and get started today",
  //     requiresAuth: false,
  //     layout: "public",
  //     analytics: {
  //       category: "Public",
  //       action: "Signup_View"
  //     }
  //   }
  // },
  // {
  //   name: "Home",
  //   path: "/home",
  //   component: lazy(() => import('src/pages/home/HomePage')),
  //   showInSideNav: true,
  //   access: ["*"], // Accessible to everyone
  //   breadcrumbPath: ["Home"],
  //   icon: "home",
  //   order: 1,
  //   meta: {
  //     title: "Welcome to Our Platform",
  //     description: "Your trusted partner for consumer services",
  //     requiresAuth: false,
  //     layout: "public",
  //     analytics: {
  //       category: "Public",
  //       action: "Home_View"
  //     }
  //   }
  // }
];